import {withTranslation} from "@sirius/ui-lib/src/blocks/LocaleBlock/WithTranslation";
import {translations}    from "Smt/translations";
import {LocalizedInput}  from "Smt/SmtLocaleBlock/FormattedInput";

const InputLocaleBlock = withTranslation(LocalizedInput, translations);
// @ts-ignore
InputLocaleBlock.displayName = 'InputLocaleBlock';

export {InputLocaleBlock};
